import { Component, OnInit } from '@angular/core';
import { timeInterval } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentService } from 'shared/services/Payment/payment.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';

@Component({
  selector: 'app-stipe-connect',
  templateUrl: './stipe-connect.component.html',
  styleUrls: ['./stipe-connect.component.css']
})
export class StipeConnectComponent implements OnInit {
  timmer: number;
  interval: any;
  code: string;
  state: string;
  loading: boolean;
  isStripeConnected: boolean;
  groupId: string;
  choosePlanObj: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private payment: PaymentService,
    private alertService: AlertPopupService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.code = params.code;
      this.state = params.state;
    });
  }

  ngOnInit() {
    this.timmer = 3;
    this.loading = true;
    this.groupId = localStorage.getItem('groupIdAfterStripeCalling');
    this.choosePlanObj = JSON.parse(localStorage.getItem('choosePlanAfterStripeCalling'));
    if (this.groupId && !this.choosePlanObj) {
      this.payment.connectStripeAccount(this.code).subscribe(response => {
        this.isStripeConnected = true;
        this.loading = false;
        this.interval = setInterval(() => {
          this.timmer = this.timmer - 1;
          if (this.timmer === 0) {
            localStorage.removeItem('groupIdAfterStripeCalling');
            this.router.navigate(['new-group/public-groups/view-details'],
              { queryParams: { groupId: this.groupId, code: this.code, state: this.state } });
            clearInterval(this.interval);
          }
        }, 1000);
      }, err => {
        this.isStripeConnected = false;
        this.loading = false;
        this.interval = setInterval(() => {
          this.timmer = this.timmer - 1;
          if (this.timmer === 0) {
            localStorage.removeItem('groupIdAfterStripeCalling');
            this.router.navigate(['new-group/public-groups/view-details'], { queryParams: { groupId: this.groupId } });
            clearInterval(this.interval);
          }
        }, 1000);
      });
    } else {
      if (!this.groupId && this.choosePlanObj && this.choosePlanObj.accountId && this.choosePlanObj.teamId) {
        this.payment.connectStripeAccount(this.code).subscribe(res => {
          this.isStripeConnected = true;
          this.loading = false;
          this.interval = setInterval(() => {
            this.timmer = this.timmer - 1;
            if (this.timmer === 0) {
              this.router.navigate(['/new-group/choose-team/upload-plan'], {
                queryParams: {
                  acctId: this.choosePlanObj.accountId, teamId: this.choosePlanObj.teamId,
                  code: this.code, state: this.state
                }
              });
              clearInterval(this.interval);
            }
          }, 1000);
        }, err => {
          this.isStripeConnected = false;
          this.loading = false;
          this.interval = setInterval(() => {
            this.timmer = this.timmer - 1;
            if (this.timmer === 0) {
              this.router.navigate(['/new-group/choose-team/upload-plan'], {
                queryParams: {
                  acctId: this.choosePlanObj.accountId, teamId: this.choosePlanObj.teamId,
                }
              });
              clearInterval(this.interval);
            }
          }, 1000);
        });
      } else {
        this.loading = false;
        this.alertService.errorAlertWithResult('Timeout Error', 'Go Back', '/new-group');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/stipe-connect/stipe-connect.component.ts